/* eslint-disable react/jsx-no-target-blank */
import NavbarNotAuth from './components/navbarNotAuth'
import { useEffect, useState, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import DivBottom from './components/divBottom'
import axios from 'axios'
import CercaFoodTruck from './components/cercaFoodTruck'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'

function FoodTruck() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const bannerCorrente = searchParams.get('banner')
    const [foodTrucks, setFoodTrucks] = useState([])
    const [dati, setDati] = useState({})// foodTruck cliccato
    const idUser = localStorage.getItem('id')
    const [tipoCucina, setTipoCucina] = useState([])
    const [img, setImg] = useState({ img: [], video: null })

    const divDettagli = useRef()
    const brnInsFoodTruck = useRef()
    const body = useRef()

    const details = { display: 'grid', gridTemplateColumns: '0.25fr .5fr', gap: '5px' }

    async function getFoodTrucks() {
        try {
            const res = await axios.post(`/getArtisti/DESC/id`)
            const rty = res.data.filter(item => item.sezione === "truck")
            setFoodTrucks(rty)
        } catch (err) { console.log(err) }
    }
    async function dettagli(e) {
        setDati(e)
        setSearchParams({ banner: 'foodTruck' })
        setImg({ img: e.img.split(','), video: e.video })
        setTipoCucina(e.genere.split(','))
        try {
            await axios.post(`/incView/${e.id}/${idUser}`)
        } catch (err) { console.log(err) }
    }
    useEffect(() => {//cosa fare quando clicco previous page
        console.log('bannerCorrente:', bannerCorrente)
        if (bannerCorrente) {
            document.body.style.overflow = 'hidden'
        } else {//quando i banner sono chiusi
            document.body.style.overflow = ''
            if (dati.video) {
                const lp = document.getElementById('videoPreview')
                lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
            }
        }
    }, [bannerCorrente])
    useEffect(() => {
        getFoodTrucks(); window.scrollTo(0, 500)
        const isRefresh = window.performance //intercetto il ricaricamneto della pagina (F5)
            ?.getEntriesByType('navigation')
            ?.[0].type === 'reload'
        if (isRefresh && searchParams.has('banner')) {//rimuovo 'banner' quando ricarico la pagina
            searchParams.delete('banner')
            setSearchParams(searchParams, { replace: true })
        }
        function lampeggiaSfondo() {
            if (brnInsFoodTruck.current.style.backgroundColor === 'mediumblue') {
                brnInsFoodTruck.current.style.color = 'black'
                brnInsFoodTruck.current.style.backgroundColor = 'gold'
            }
            else {
                brnInsFoodTruck.current.style.backgroundColor = 'mediumblue'
                brnInsFoodTruck.current.style.color = 'whitesmoke'
            }
        }
        const intervallo = setInterval(lampeggiaSfondo, 1000)
        return () => clearInterval(intervallo)
    }, [])

    // useEffect(() => { console.log('formData.messaggio:', formData.messaggio) }, [formData.messaggio])

    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <p style={{ margin: '5rem 0 0 2rem' }}>\<b>foodtruck</b></p>
        <CercaFoodTruck />
        <div className='text-center'>
            <button ref={brnInsFoodTruck} style={{ width: '80%', padding: '10px 5px', backgroundColor: 'red', fontWeight: '700', borderRadius: '10px', fontSize: 'large' }}
                onClick={() => {
                    navigate('/addFoodtruck')
                }}>INSERISCI IL TUO FOOD TRUCK
            </button>
        </div>

        <div className='mt-4 bodyPadding' ref={body} style={{ padding: '0 2em' }}>
            {foodTrucks &&
                foodTrucks
                    .filter(item => (item.accettazione === 'true'))
                    .map(elem => {
                        let arrImg; let arrTipoCucina = []
                        if (elem.img) arrImg = elem.img.split(',')
                        if (elem.genere) arrTipoCucina = elem.genere.split(',')
                        return (
                            <div key={elem.id} className='mt-5'>
                                {elem.img ?
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/${arrImg[0]}`}
                                        style={{ maxWidth: '250px', maxHeight: '130px', borderRadius: '5px', objectFit: 'cover' }} alt='' />
                                    :
                                    <img src={require('./image/icons8-impostazioni-amministratore-maschio-32.png')} alt='' />
                                }
                                <div style={{ color: 'navy', fontWeight: '500', fontSize: 'x-large', fontFamily: 'Times New Roman' }}>{elem.nome}</div>

                                <p style={{ margin: '1em 0 1em 0', fontWeight: '600' }}>
                                    {elem.regione} ({elem.città})
                                </p>

                                {arrTipoCucina.length !== 0 &&
                                    <div className='mt-3' style={{ display: 'grid', gridTemplateColumns: '0.1fr 1fr', gap: '5px' }}>
                                        <div>
                                            <img src={require("./image/icons8-cucina-48.png")} width={27} alt='' />
                                        </div>
                                        <div>
                                            {arrTipoCucina.map((elem, index) => {
                                                let vbn
                                                switch (elem) {
                                                    case "italiana": vbn = 'Cucina italiana tradizionale'; break
                                                    case "hamburger": vbn = 'Hamburger & Fast Food'; break
                                                    case "etnica": vbn = 'Etnica/Internazionale'; break
                                                    case "vegetariana": vbn = 'Vegetariana'; break
                                                    case "vegana": vbn = 'Vegana'; break
                                                    case "dolci": vbn = 'Dolci & Gelati'; break
                                                    case "bar": vbn = 'Bar/Cocktail/Birre/Frullati/Centrifugati'; break
                                                    case "griglia": vbn = 'Griglia & Barbecue'; break
                                                    default:
                                                }
                                                return (
                                                    <span key={index}>{vbn}
                                                        {index < arrTipoCucina.length - 1 && <span>, </span>}
                                                    </span>
                                                )
                                            })}
                                        </div>
                                    </div>
                                }
                                {elem.telefono &&
                                    <div className='mt-2' style={{ display: 'grid', gridTemplateColumns: '0.1fr 1fr', gap: '5px' }}>
                                        <div>
                                            <img src={require('./image/icons8-telefono-cellulare-48.png')} width='25rem' alt='' />
                                        </div>
                                        <div>{elem.telefono}</div>
                                    </div>
                                }
                                {elem.url &&
                                    <div className='mt-2' style={{ display: 'grid', gridTemplateColumns: '0.1fr 1fr', gap: '5px' }}>
                                        <div>
                                            <a href={elem.url} style={{ textDecoration: 'none', color: 'black' }} target='_blank' rel="noreferrer">
                                                <img src={require("./image/icons8-sito-web-30.png")} style={{ opacity: '.7' }} alt='' />
                                            </a>
                                        </div>
                                        <div>
                                            <a href={elem.url} style={{ textDecoration: 'none', color: 'black' }} target='_blank' rel="noreferrer"> Sito web </a>
                                        </div>
                                    </div>
                                }

                                <div style={{ marginTop: '1rem', marginBottom: '4rem' }}>
                                    <button className='btn btn-primary float-start' onClick={() => { dettagli(elem) }}
                                        style={{ fontSize: 'small', fontWeight: '600' }}>
                                        Dettagli
                                    </button>

                                    {/* {parseInt(elem.idUser) !== parseInt(formData.userId) &&
                                        <button className='btn btn-primary float-start'
                                            onClick={() => { messaggio(elem) }}
                                            style={{ fontSize: 'small', fontWeight: '600', marginLeft: '1rem' }}>
                                            <img src={require('./image/icons8-messaggio-di-chat-50.png')} style={{ width: '16%', marginLeft: '-15%' }} alt=''/> Messaggio
                                        </button>
                                    } */}
                                </div>
                                <hr style={{ height: '2px', backgroundColor: 'black' }} />
                            </div>
                        )
                    }
                    )
            }
            {/* --------- BANNER DEI DETTAGLI FOODTRUCK ---------- */}
            <div className='visualDettagli' style={{ top: `${bannerCorrente === 'foodTruck' ? '0' : '120%'}` }} >
                {dati.length !== 0 &&
                    <div className='mt-3'>
                        <div style={{
                            fontSize: '28px', float: 'right', cursor: 'pointer', borderRadius: '50%', backgroundColor: 'lightgrey', textAlign: 'center',
                            width: '45px', height: '45px', fontWeight: '600'
                        }} onClick={() => {
                            if (dati.video) {
                                const lp = document.getElementById('videoPreview')
                                lp.pause(); lp.currentTime = 0// Riporta il video all'inizio
                            }
                            window.history.back()
                        }}>X
                        </div><br />
                        <div style={{ marginBottom: '1rem' }}>
                            {dati.img ?
                                <img src={`https://leuro-bucket.s3.amazonaws.com/${img.img[0]}`} alt=''
                                    style={{ maxWidth: '80%', maxHeight: '250px', marginTop: '2em', border: '1px solid lightgrey', borderRadius: '10px' }} />
                                : <img src={require('./image/icons8-impostazioni-amministratore-maschio-32.png')} alt='' />
                            }
                        </div>
                        <div className='p-1' style={{ width: 'fit-content', backgroundColor: 'lightgray' }}>{dati.view} view</div>
                        <h4 className='mt-3' style={{ fontFamily: 'Times New Roman', color: 'navy' }}>{dati.nome}</h4>

                        {dati.genere &&
                            <div style={details} className='mt-3'>
                                <div>Genere:</div>
                                <div style={{ marginLeft: '5px' }}>
                                    {tipoCucina.map((elem, index) => {
                                        let vbn
                                        switch (elem) {
                                            case "italiana": vbn = 'Cucina italiana tradizionale'; break
                                            case "hamburger": vbn = 'Hamburger & Fast Food'; break
                                            case "etnica": vbn = 'Etnica/Internazionale'; break
                                            case "vegetariana": vbn = 'Vegetariana'; break
                                            case "vegana": vbn = 'Vegana'; break
                                            case "dolci": vbn = 'Dolci & Gelati'; break
                                            case "bar": vbn = 'Bar/Cocktail/Birre/Frullati/Centrifugati'; break
                                            case "griglia": vbn = 'Griglia & Barbecue'; break
                                            default:
                                        }
                                        return (
                                            <span key={index}>{vbn}
                                                {index < tipoCucina.length - 1 && <span>, </span>}
                                            </span>
                                        )
                                    })}
                                </div>
                            </div>
                        }

                        <div style={details} className='mt-3'>
                            <div>Specialità:</div><div><b>{dati.soggetto}</b></div>

                            <div>Regione:</div><div><b>{dati.regione}</b></div>
                            <div>Città:</div><div><b> {dati.città}</b></div>
                        </div>
                        <hr />

                        <div style={details} className='mt-5'>
                            <div><img src={require('./image/icons8-nuovo-messaggio-48.png')} width='25rem' alt='' /></div><div><b>{dati.emailUser}</b></div>
                        </div>
                        {dati.telefono !== '' &&
                            <div style={details} className='mt-2'>
                                <div><img src={require('./image/icons8-telefono-cellulare-48.png')} width='25rem' alt='' /></div><div><b>{dati.telefono}</b></div>
                            </div>
                        }
                        <textarea className='textAreaEventi' rows='7' style={{ borderTop: '1px solid grey' }} value={dati.descrizione} />

                        {img.img[0] !== '' &&
                            <div style={{ margin: '1em auto' }} className='row'>
                                {img.img.map((elem, index) => {
                                    // if (index !== 0) 
                                    return (
                                        <div key={index} className="mt-3" style={{ width: '22rem', height: '100%' }}>
                                            {/* {index !== 0 && */}
                                            <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} alt=''
                                                style={{ maxWidth: '100%', maxHeight: '200px' }} className='rounded' />
                                            {/* } */}
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        {img.video &&
                            <div className='mt-5' style={{ border: '1px solid lightgrey', borderRadius: '5px', padding: ' 15px' }}>
                                <h5 className='text-center'>VIDEO DEL FOODTRUCK</h5>
                                <div className='text-center mt-3'>
                                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${img.video}`} id={'videoPreview'}
                                        style={{ width: '100%', maxHeight: '400px', borderRadius: '5px' }} controls />
                                </div>
                            </div>
                        }

                        <div style={{ border: '1px solid lightgrey', borderRadius: '20px', padding: '15px 5px', marginTop: '2rem' }}>
                            <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                            {dati.url &&
                                <div className='btn btn-warning'>
                                    <a href={dati.url} style={{ textDecoration: 'none', color: 'navy' }} target='_blank'>Sito web</a>
                                </div>
                            }
                            {dati.fb &&
                                <span style={{ backgroundColor: 'royalblue', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                    <a href={dati.fb} style={{ textDecoration: 'none', color: 'white', fontSize: 'x-large' }} target='_blank' rel="noreferrer"><b>f</b></a>
                                </span>
                            }
                            {dati.youtube &&
                                <span style={{ backgroundColor: 'red', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                    <a href={dati.youtube} style={{ textDecoration: 'none', color: 'white' }} target='_blank' rel="noreferrer"><b>▷</b></a>
                                </span>
                            }
                            {!dati.url && !dati.fb && !dati.youtube &&
                                <div>Nessun link presente </div>
                            }
                        </div>

                        <div className='mt-5'>
                            <button className='btn btn-secondary'
                                onClick={() => {
                                    divDettagli.current.style.top = '120%'; document.body.style.overflow = 'scroll'
                                }}>Indietro
                            </button>
                        </div><br /><br />
                    </div>
                }
            </div>
        </div>
        <DivBottom />
    </>)
}
export default FoodTruck